var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCardBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_358_7479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 1.5H2.5C1.8372 1.50079 1.20178 1.76444 0.73311 2.23311C0.264441 2.70178 0.000793929 3.3372 0 4H12C11.9992 3.3372 11.7356 2.70178 11.2669 2.23311C10.7982 1.76444 10.1628 1.50079 9.5 1.5Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0.000793929 8.66279 0.264441 9.29822 0.73311 9.76688C1.20178 10.2356 1.8372 10.4992 2.5 10.5H9.5C10.1628 10.4992 10.7982 10.2356 11.2669 9.76688C11.7356 9.29822 11.9992 8.66279 12 8V5H0V8ZM3.5 7.75C3.5 7.89833 3.45601 8.04334 3.3736 8.16667C3.29119 8.29001 3.17406 8.38614 3.03701 8.4429C2.89997 8.49967 2.74917 8.51452 2.60368 8.48558C2.4582 8.45665 2.32456 8.38521 2.21967 8.28033C2.11478 8.17544 2.04335 8.0418 2.01441 7.89631C1.98547 7.75083 2.00032 7.60003 2.05709 7.46298C2.11386 7.32594 2.20999 7.20881 2.33332 7.12639C2.45666 7.04398 2.60166 7 2.75 7C2.94891 7 3.13968 7.07901 3.28033 7.21967C3.42098 7.36032 3.5 7.55108 3.5 7.75Z",
    fill: "#262626"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_358_7479"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardBlack);
export default __webpack_public_path__ + "static/media/creditCardBlack.9789367a08bc4dae7f69062b0dfcc60e.svg";
export { ForwardRef as ReactComponent };